// libs
import classNames from 'classnames'
import * as React from 'react'
import { CLASS_PREFIX } from 'src/constants/'

// components
import withPortal from 'src/high_order_components/with_portal'

// helpers
import './modal.scss'
import * as closeIcon from 'src/components/modal/close.svg'

export interface IModalProps {
  children?: JSX.Element;
  onClose?: () => void;
  noBorderRadius?: boolean;
  customClassNames?: string;
  autoSize?: boolean;
  showLarge?: boolean;
  hideCloseButton?: boolean;
}

const cls = `${CLASS_PREFIX}modal`
const clsBackdrop = `${cls}__backdrop`
const clsBody = `${cls}__body`
const BODY_CLASS = `${CLASS_PREFIX}body--modal-open`
const bodyElement: HTMLElement = document.body

class Modal extends React.Component<IModalProps, object> {
  public componentDidMount () {
    bodyElement.classList.add(BODY_CLASS)
  }

  public componentWillUnmount () {
    bodyElement.classList.remove(BODY_CLASS)
  }

  public render () {
    const { children, onClose, customClassNames, autoSize, showLarge, hideCloseButton } = this.props
    return (
      <div className={cls}>
        <div className={clsBackdrop} onClick={showLarge ? () => {} : onClose} />
        <div className={classNames(clsBody, customClassNames, !autoSize && `${clsBody}${showLarge ? '--large' : '--small'}`)}>
          {!hideCloseButton && (
            <div className={clsBody + '__close'} onClick={onClose}>
              <img src={closeIcon} alt="close"/>
            </div>
          )}

          {children}
        </div>
      </div>
    )
  }
}

export default withPortal(Modal)
